// 全局Loading组件
class GlobalLoading {
  constructor() {
    this.overlay = null;
    this.loadingTimeout = null;
    this.isInitialized = false;
    this.imagesLoaded = false;
    this.pendingShow = null;
    this.preloadTimeout = null;
    this.init();
  }

  // 初始化loading组件
  init() {
    if (this.isInitialized) return;

    this.createLoadingOverlay();
    this.addEventListeners();
    this.preloadImages();

    this.isInitialized = true;
  }

  // 预加载图片
  preloadImages() {
    const imagesToPreload = [
      "https://cdn.shopify.com/s/files/1/0826/0724/3608/files/loading-logo.svg",
      "https://cdn.shopify.com/s/files/1/0826/0724/3608/files/loading-scan.png",
    ];

    let loadedCount = 0;
    const totalImages = imagesToPreload.length;

    const onImageLoad = () => {
      loadedCount++;
      if (loadedCount === totalImages) {
        this.imagesLoaded = true;
        // 清除超时定时器
        if (this.preloadTimeout) {
          clearTimeout(this.preloadTimeout);
          this.preloadTimeout = null;
        }
        // 如果有待处理的显示请求，立即执行
        if (this.pendingShow) {
          this.executeShow(this.pendingShow);
          this.pendingShow = null;
        }
      }
    };

    const onImageError = (src) => {
      console.warn(`Failed to preload image: ${src}`);
      onImageLoad(); // 即使加载失败也继续
    };

    imagesToPreload.forEach((src) => {
      const img = new Image();
      img.onload = onImageLoad;
      img.onerror = () => onImageError(src);
      img.src = src;
    });

    // 添加3秒超时机制，防止图片加载过慢
    this.preloadTimeout = setTimeout(() => {
      console.warn("Image preloading timeout, showing loading anyway");
      this.imagesLoaded = true;
      if (this.pendingShow) {
        this.executeShow(this.pendingShow);
        this.pendingShow = null;
      }
    }, 3000);
  }

  // 创建loading覆盖层
  createLoadingOverlay() {
    if (document.querySelector(".global-loading-overlay")) return;

    const overlay = document.createElement("div");
    overlay.className = "global-loading-overlay hidden";
    overlay.innerHTML = `
      <div class="container-loading-logo">
        <div class="loading-logo">
          <div class="scan-logo"></div>
          <img src="https://cdn.shopify.com/s/files/1/0826/0724/3608/files/loading-logo.svg" alt="loading">
        </div>
      </div>
    `;

    // 添加样式
    const style = document.createElement("style");
    style.textContent = `
      .global-loading-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.2);
        backdrop-filter: blur(2px);
        -webkit-backdrop-filter: blur(2px);
        z-index: 9999;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: opacity 0.3s ease;
      }

      .global-loading-overlay.hidden {
        display: none;
      }

      .global-loading-overlay .container-loading-logo {
        width: 200px;
        height: 200px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 30px;
        position: relative;
        background: #3f3f3ffa;
        border-radius: 20px;
        backdrop-filter: blur(10px);
        -webkit-backdrop-filter: blur(10px);
        animation: fadeInScale 0.3s ease;
      }
      

      .global-loading-overlay .loading-logo {
        width: 74px;
        height: 74px;
        position: relative;
        overflow: hidden;
        border-radius: 49%;
      }

      .global-loading-overlay .loading-logo img {
        width: 74px;
        height: 74px;
        display: block;
      }

      .global-loading-overlay .scan-logo {
        width: 86px;
        height: 86px;
        position: absolute;
        top: -1px;
        left: -5px;
        overflow: hidden;
        border-radius: 50%;
        animation: rotate 1.5s linear infinite;
       background: url('https://cdn.shopify.com/s/files/1/0826/0724/3608/files/loading-scan.png') no-repeat;
        background-size: 100% 100%;
        z-index: 1;
        display: block !important;
      }

      @keyframes rotate {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }

      @keyframes fadeInScale {
        0% {
          transform: scale(0.8);
          opacity: 0;
        }
        100% {
          transform: scale(1);
          opacity: 1;
        }
      }
    `;

    document.head.appendChild(style);
    document.body.appendChild(overlay);
    this.overlay = overlay;
  }

  // 添加事件监听器
  addEventListeners() {
    // 页面可见性变化时处理loading
    document.addEventListener("visibilitychange", () => {
      if (document.hidden) {
        this.hide();
      }
    });
  }

  // 显示loading
  show(options = {}) {
    if (!this.overlay) {
      this.createLoadingOverlay();
    }

    // 如果图片已经加载完成，立即显示
    if (this.imagesLoaded) {
      this.executeShow(options);
    } else {
      // 图片未加载完成，保存显示请求
      this.pendingShow = options;

      // 如果图片加载时间过长，500ms后强制显示
      setTimeout(() => {
        if (this.pendingShow && !this.imagesLoaded) {
          console.warn("Showing loading without fully loaded images");
          this.imagesLoaded = true;
          this.executeShow(this.pendingShow);
          this.pendingShow = null;
        }
      }, 500);
    }

    return this;
  }

  // 执行显示loading
  executeShow(options = {}) {
    const { timeout = 10000, message = "" } = options;

    this.overlay.classList.remove("hidden");
    document.body.classList.add("overflow-hidden");

    // 如果有自定义消息，可以添加到loading中
    if (message) {
      this.setMessage(message);
    }

    // 添加超时机制
    if (timeout > 0) {
      this.loadingTimeout = setTimeout(() => {
        this.hide();
      }, timeout);
    }

    return this;
  }

  // 隐藏loading
  hide() {
    if (this.overlay) {
      this.overlay.classList.add("hidden");
      document.body.classList.remove("overflow-hidden");

      // 清除超时定时器
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout);
        this.loadingTimeout = null;
      }

      // 清除消息
      this.clearMessage();
    }

    return this;
  }

  // 设置loading消息
  setMessage(message) {
    if (!this.overlay) return;

    let messageElement = this.overlay.querySelector(".loading-message");
    if (!messageElement) {
      messageElement = document.createElement("div");
      messageElement.className = "loading-message";
      messageElement.style.cssText = `
        position: absolute;
        bottom: -50px;
        left: 50%;
        transform: translateX(-50%);
        color: #666;
        font-size: 14px;
        text-align: center;
        white-space: nowrap;
      `;
      this.overlay
        .querySelector(".container-loading-logo")
        .appendChild(messageElement);
    }

    messageElement.textContent = message;
  }

  // 清除loading消息
  clearMessage() {
    if (!this.overlay) return;

    const messageElement = this.overlay.querySelector(".loading-message");
    if (messageElement) {
      messageElement.remove();
    }
  }

  // 检查是否正在显示
  isVisible() {
    return this.overlay && !this.overlay.classList.contains("hidden");
  }
}

// 创建全局实例
window.GlobalLoading = new GlobalLoading();

// 提供简化的全局方法
window.showLoading = (options) => window.GlobalLoading.show(options);
window.hideLoading = () => window.GlobalLoading.hide();
